import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

class ProgressBar extends Component {
  getCircleParameters() {
    const {radius, stroke} = this.props;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {normalizedRadius, circumference}
  }

  render() {
    const {radius, stroke, progress} = this.props;
    const {normalizedRadius, circumference} = this.getCircleParameters();
    const strokeDashoffset = circumference - progress / 100 * circumference;

    return (
      <svg
        height={radius * 2}
        width={radius * 2}
      >
        <circle
          className={styles.backgroundCircle}
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          className={styles.circle}
          strokeWidth={stroke}
          strokeDasharray={circumference + ' ' + circumference}
          style={{strokeDashoffset}}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
    );
  }
}

ProgressBar.propTypes = {
  radius: PropTypes.number.isRequired,
  stroke: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired
};

export default ProgressBar;
